// extracted by mini-css-extract-plugin
export default {"JobDetails__tag":"EditLabel_JobDetails__tag__e4rJ4","tag":"EditLabel_tag__DbsGM"};